import React, { useEffect } from 'react'
import { useState } from 'react'
import axios from 'axios';
import { useSelector } from 'react-redux';
import LoadingScreen from '../components/LoadingScreen/LoadingScreen';
import { Container, Row, Col, Button, CardGroup, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReactSelect from 'react-select';
import defaultImg from './../assets/images/default.png'
import NoResult from './../components/NoResult'

export default function Stores() {
    const PF = process.env.REACT_APP_FIND_API_URL + "/images/";
    const [stores, setStores] = useState([]);
    const { user } = useSelector((state) => state.auth);
    const sellerId = user.seller_profile_id;
    const [type, setType] = useState([]);
    const [search, setSearch] = useState("");
    const [typeFilter, setTypeFilter] = useState();

    const handleTypeFilter = (e) => {
        setTypeFilter(e.value)
    }

    const [isLoading, setIsLoading] = useState(true);
    const DELAY_TIME = 1500;

    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            let filters = {}
            if (typeFilter !== '') {
                filters['seller_store_register.seller_type_id'] = typeFilter;
            }
            if (search?.length > 0) {
                filters['seller_store_name'] = search;
            }
            axios.post(process.env.REACT_APP_FIND_API_URL + `/store/get-stores/${sellerId}`, { filters: filters }, {withCredentials: true}).then((res) => {
                setStores(res.data);
                setIsLoading(false)
            }).catch((err)=> {
                setIsLoading(false)
            })
        }, DELAY_TIME);
        return () => {
            clearTimeout(pageTimeout);
        }
    }, [typeFilter, sellerId, search]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_FIND_API_URL + '/seller-type/get', {withCredentials: true}).then((res) => {
            const getTypes = res.data.map((t) => ({ value: t.seller_type_id, label: t.seller_type_name }))
            setType(getTypes);
        })
    }, [])

    return (
        <>
            {
                isLoading ? (
                    <LoadingScreen />
                ) : !stores[0] ?
                    <NoResult name="stores" link={'/sell-on-findNow'} />
                    : (<>
                        <Container fluid>
                            <Row className='mb-5'>
                                <Col md="3">
                                    <div className="topnav__search">
                                        <input type="text" placeholder='Search here...' onChange={(e) => setSearch(e.target.value)} />
                                        <i className='bx bx-search'></i>
                                    </div>
                                </Col>
                                <Col md="3"></Col>
                                <Col md="3">
                                    <ReactSelect options={type} onChange={(e) => handleTypeFilter(e)} />
                                </Col>
                                <Col md="3" className='text-end'>
                                    <Link to='/sell-on-findNow'>
                                        <Button>Add Store +</Button>
                                    </Link>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    stores.map((store) => (
                                        <Col md={4}>
                                            <CardGroup>
                                                <Card>
                                                    {store.seller_store_logo !== null ?
                                                        <Card.Img width={'80px'} height={'200px'} variant="top" src={PF + store.seller_store_logo} />
                                                        :
                                                        <Card.Img width={'80px'} height={'200px'} variant="top" src={defaultImg} />
                                                    }
                                                    <Card.Body>
                                                        <Card.Title>{store.store_name}</Card.Title>
                                                        <Card.Text>
                                                            Address: {store.address}
                                                        </Card.Text>
                                                        {
                                                            store.seller_type === "Local Seller" ?
                                                                <Link to={'/admin/local-seller-products'} state={{ id: store.id }}>
                                                                    <Button>View Products</Button>
                                                                </Link>
                                                                :
                                                                store.seller_type === "Store/Mart" ?
                                                                    <Link to={'/admin/store-products'} state={{ id: store.id }}>
                                                                        <Button>View Products</Button>
                                                                    </Link>
                                                                    :
                                                                    store.seller_type === "Tech Store" ?
                                                                        <Link to={'/admin/tech-products'} state={{ id: store.id }}>
                                                                            <Button>View Products</Button>
                                                                        </Link>
                                                                        :
                                                                        store.seller_type === "Health Medical" ?
                                                                            <Link to={'/admin/health-products'} state={{ id: store.id }}>
                                                                                <Button>View Products</Button>
                                                                            </Link>
                                                                            :
                                                                            ""
                                                        }
                                                    </Card.Body>
                                                    <Card.Footer>
                                                        <small className="text-muted">{store.seller_type}</small>
                                                    </Card.Footer>
                                                </Card>
                                            </CardGroup>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Container>
                    </>
                    )
            }
        </>
    )
}